import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ShopColumnThreeMain from './ShopColumnThreeMain';
import Footer from '../../components/Footer';
import ProductModal from '../../components/Modal/ProductModal';

const ShopColumnThree = () => {
  return (
    <>
      <ProductModal />

      <HeaderSeven />

      <ShopColumnThreeMain />

      <Footer />
    </>
  );
};

export default ShopColumnThree;
